export default class Incidencias {

    constructor($scope,
                $rootScope,
                $location,
                $routeParams,
                method,
                incidenciaService,
                tipoEquipoService,
                ubicacionService,
                clientesService,
                proyectosService,
                inventarioService,
                alertasService,
                severidadesService,
                centroCostosService,
                unidadEjecutoraService,
                prioridadesService,
                tipoIncidenciaService,
                PreincidenciaToIncidencia,
                $uibModal,
                usuariosService,
                estadosService,
                baseUrl,
                objetoUbicacionService,
                tipoUbicacionesService,
                toastr,
                info,
                filtros) {

        this.scope = $scope;
        this.routeParams = $routeParams;
        this.rootScope = $rootScope;
        this.scope.crearOrdenTrabajo = this.crearOrdenTrabajo.bind(this);
        this.location = $location;
        this.tipoEquipoService = tipoEquipoService;
        this.baseUrl = baseUrl;
        this.toastr = toastr;
        this.scope.info = info;
        this.scope.handleDisplayFilters = this.handleDisplayFilters.bind(this);
        this.scope.displayFilters = false;

        var self = this;
        this.scope.$watch("info.get('permisos')", function (newVal) {
            if(angular.isDefined(newVal.in)) {
                self.scope.readOnly = !newVal.in.w;
            }
        });

        switch (method) {
            case 'list':
                this.scope.nombre = "Detalle Incidencia";
                this.list(incidenciaService, 
                            ubicacionService, 
                            clientesService, 
                            proyectosService, 
                            tipoIncidenciaService, 
                            estadosService, 
                            severidadesService, 
                            PreincidenciaToIncidencia,
                            filtros,
                            info);
                this.scope.descargarExcel = this.descargarExcel.bind(this);
                break;

            case 'view':
                this.viewIncidencia(
                    incidenciaService,
                    inventarioService,
                    alertasService,
                    severidadesService,
                    clientesService,
                    proyectosService,
                    centroCostosService,
                    unidadEjecutoraService,
                    prioridadesService,
                    tipoIncidenciaService,
                    tipoEquipoService,
                    usuariosService,
                    ubicacionService,
                    estadosService
                );
                this.uibModal = $uibModal;
                this.incidenciaService = incidenciaService;
                this.scope.actualizar = this.actualizarIncidencia.bind(this);
                this.scope.addObservacion = this.addObservacion.bind(this);
                this.scope.anularIncidencia = this.anularIncidencia.bind(this);
                this.scope.getPdf = this.getPdf.bind(this);
                break;

            case 'new':
                this.scope.nombre = "Nueva incidencia";
                this.incidenciaService = incidenciaService;
                this.scope.newIncidencia = this.newIncidencia.bind(this);
                this.newIncidenciaForm(
                    incidenciaService,
                    inventarioService,
                    alertasService,
                    severidadesService,
                    clientesService,
                    proyectosService,
                    centroCostosService,
                    unidadEjecutoraService,
                    prioridadesService,
                    tipoIncidenciaService,
                    PreincidenciaToIncidencia,
                    ubicacionService,
                    estadosService,
                    objetoUbicacionService,
                    tipoUbicacionesService
                );
                break;
        }
    }

    list(incidenciaService, ubicacionService, clientesService, proyectosService, tipoIncidenciaService, 
            estadosService, severidadesService, PreincidenciaToIncidencia, filtros, info) {

        PreincidenciaToIncidencia.clear();

        this.scope.userProyects = info.get('proyectos');
        
        if (localStorage.getItem('cliente') == 'SCADA') {
            this.scope.nombre = 'Incidencias';
        }
        this.scope.aux = {
            filters: {}
        };
        this.scope.filtros = filtros.incidencia;

        this.scope.showIncidencia = (incidencia) => {
            this.location.path('/incidencia/' + incidencia._id);
        };

        tipoIncidenciaService.getAll()
            .then((resp) => {
                let data = resp.data.message.map((el) => {
                    el.nombre_interno = 'tipo_incidencia._id';
                    return el;
                });
                this.scope.aux.tipo_incidencias = data;
            });

        estadosService.getAll({grupo: 'incidencia'})
            .then((resp) => {
                
                let data = resp.data.message.map((el) => {
                    
                    el.nombre_interno = 'estado._id';
                    if(el.index === 1) {
                        this.scope.filtros.estado = el;
                    }
                    return el;
                });
                this.scope.aux.estado_incidencias = data;

                //Se buscan las incidencias en estado pendiente
                let filter = {
                    activo: true,
                    'estado._id' :  this.scope.filtros.estado._id
                };
                filter = JSON.stringify(filter);
                incidenciaService.getAll(filter).then((resp, err) => {
                    if (err || resp.status !== 200) {
                        console.log('error en la peticion');
                    } else {
                        this.scope.incidencias = resp.data.message;
                    }
                })
                .catch((data) => {
                    console.log('url no encontrada');
                });
            });

        severidadesService.getAll()
            .then((resp) => {
                let data = resp.data.message.map((el) => {
                    el.nombre_interno = 'severidad._id';
                    return el;
                });
                this.scope.aux.severidad_incidencias = data;
            });

        

        

        clientesService.getAll().then((resp, err) => {
            let data = resp.data.message.map((el) => {
                el.nombre_interno = 'proyecto.cliente._id';
                return el;
            });
            this.scope.aux.clientes = data;
        });

        this.scope.$watch("filtros.clientes", (nuevo) => {
            if (!Array.isArray(nuevo) && nuevo !== null) {
                let filter = {
                    'clientes': nuevo._id
                };
                proyectosService.getByCliente(filter).then((respPro, err) => {
                    let data = respPro.data.message.map((el) => {
                        el.nombre_interno = 'proyecto';
                        return el;
                    });
                    this.scope.aux.proyectos = data;
                });
            } else {
                this.scope.aux.proyectos = [];
            }
        });


        let arWatch = ['filtros.clientes', 'filtros.proyectos', 'filtros.tipo', 'filtros.estado', 'filtros.severidad'];

        this.scope.$watchGroup(arWatch, (nuevo) => {
            let filtro = {
                activo: true
            };
            for (var el in nuevo) {
                let element = nuevo[el];
                if (element && element !== null && typeof element !== 'undefined') {
                    filtro[element.nombre_interno] = element._id;
                }
            }
            this.scope.aux.query = filtro;
            filtro = JSON.stringify(filtro);

            incidenciaService.getAll(filtro)
                .then((resp, err) => {
                    if (err || resp.status !== 200) {
                        console.log('error en la peticion');
                    } else {
                        this.scope.incidencias = [];
                        this.scope.incidencias = resp.data.message;
                    }
                })
                .catch((data) => {
                    console.log('url no encontrada');
                    console.log(data);
                });

        });

        this.scope.getUbicacion = this.getUbicacion.bind(this);
    }

    descargarExcel() {
        var url = window.location;
        var urlNew = this.baseUrl + '/api/incidencias/excel' + '?token=' + localStorage.getItem('token') + '&string=' + JSON.stringify(this.scope.aux.query);
        window.open(urlNew);
    }

    newIncidenciaForm(incidenciaService,
                      inventarioService,
                      alertasService,
                      severidadesService,
                      clientesService,
                      proyectosService,
                      centroCostosService,
                      unidadEjecutoraService,
                      prioridadesService,
                      tipoIncidenciaService,
                      PreincidenciaToIncidencia,
                      ubicacionService,
                      estadosService,
                      objetoUbicacionService,
                      tipoUbicacionesService) {

        let self = this.scope;
        if (this.scope.readOnly) {
            this.location.path('/incidencia/');
        }
        this.scope.aux = {
            fecha_incidencia: '',
            fecha_reporte: '',
            selects: {}
        };
        this.scope.incidencia = {};

        this.scope.incidencia.preincidencia = PreincidenciaToIncidencia.getPreincidencia();

        if (this.scope.incidencia.preincidencia) {
            this.scope.aux.flag_precincidencia = true;
            this.scope.aux.fecha_incidencia = moment(new Date(this.scope.incidencia.preincidencia.fecha_incidencia)).utc();
            this.scope.aux.fecha_incidencia = this.scope.aux.fecha_incidencia.format('DD/MM/YYYY HH:mm');
            this.scope.aux.fecha_reporte = this.scope.aux.fecha_incidencia;
            this.scope.incidencia.observaciones = this.scope.incidencia.preincidencia.falla;
            let equipo = this.scope.incidencia.preincidencia.equipo;
            
            if(equipo.includes("/")) {
                equipo = equipo.substring(equipo.lastIndexOf("/") + 1, equipo.length);
            }
            let filter = {
                'ubicacion.posicion.nombre': equipo
            };
            filter = JSON.stringify(filter);
            inventarioService.getAll(filter)
                .then((resp) => {

                    if (resp.data.message.length <= 0) return false;

                    let equipo = resp.data.message[0];
                    // seteamos el equipo
                    this.scope.aux.equipos = resp.data.message;
                    this.scope.incidencia.equipo = equipo;

                    // seteamos el proyecto
                    this.scope.aux.proyectos = [equipo.proyecto];
                    this.scope.incidencia.proyecto = equipo.proyecto;

                    // objeto ubicacion
                    this.scope.incidencia.objeto_ubicacion = equipo.ubicacion[Object.keys(equipo.ubicacion)[0]].objeto_ubicacion;
                    
                    this.scope.incidencia.ubicacion = {};

                    let ubicacion = this.scope.incidencia.equipo.ubicacion;
                    for (var key in ubicacion) {
                        let aux = ubicacion[key];
                        this.scope.aux.selects[aux.tipo.nombre_interno + 's'] = [aux];
                        this.scope.incidencia.ubicacion[aux.tipo.nombre_interno] = aux;
                    }
                });
            

                let falla = this.scope.incidencia.preincidencia.falla;
        } else {
            this.scope.aux.flag_precincidencia = false;
        }

        proyectosService.getAll().then((resp, err) => {
            this.scope.aux.proyectos = resp.data.message;
        });

        /*objetoUbicacionService.getAll()
            .then((resp, err) => {
                this.scope.aux.objeto_ubicaciones = resp.data.message;
            });*/


        this.scope.$watch('incidencia.objeto_ubicacion', (nuevo) => {
            if (typeof nuevo !== 'undefined' && nuevo != null && typeof this.scope.incidencia.proyecto !== 'undefined') {
                let filter = {
                    "objeto_ubicacion._id": nuevo._id
                };

                tipoUbicacionesService.getAll(filter)
                    .then((resp, err) => {
                        this.scope.aux.tipo_ubicaciones = resp.data.message;
                        ubicaciones();

                        let filter = {
                            "tipo.indice": 50,
                            "objeto_ubicacion._id": nuevo._id,
                            "proyecto._id": this.scope.incidencia.proyecto._id
                        };

                        ubicacionService.getAll(filter).then((resp, err) => {
                            if (!err) {
                                if (resp.data.message.length == 0) {
                                    this.toastr.warning('No existen sectores disponibles para el area seleccionada!', {
                                        timeOut: 2000,
                                        closeButton: true
                                    });
                                }

                                if (!this.scope.aux.flag_precincidencia) {
                                    let index = this.scope.aux.tipo_ubicaciones[0].nombre_interno + 's';
                                    this.scope.aux.selects[index] = resp.data.message;
                                }
                            }
                        });
                    });
            } else if(typeof nuevo !== 'undefined'){
                this.toastr.warning('Debe seleccionar un proyecto!', {
                    timeOut: 2000,
                    closeButton: true
                });
            }
        });

        this.scope.$watch('incidencia.proyecto', (nuevo) => {

            if(typeof nuevo !== 'undefined') {
                let filter = {
                    proyecto : nuevo._id
                }
                objetoUbicacionService.getAll(filter)
                    .then((resp, err) => {
                        this.scope.aux.objeto_ubicaciones = resp.data.message;
                    });
            }
            
        });

        this.scope.$watch('incidencia.equipo', (nuevo) => {
            if (!nuevo) return false;
            let filter = {
                'tipo_equipo': nuevo.tipo_equipo._id
            };

            alertasService.getAll(filter).then((resp, err) => {
                this.scope.aux.alertas = resp.data.message;
                if (self.incidencia.preincidencia) {
                    this.scope.aux.alertas.forEach(function(alerta){
                        if(alerta.nombre === self.incidencia.preincidencia.falla) {
                            self.incidencia.alerta = alerta;
                        }
                    });
                }
            });
        });

        var ubicaciones = () => {
            if (this.scope.aux.flag_precincidencia) {
                return false;
            }
            let data = this.scope.aux.tipo_ubicaciones;

            let arCollection = [];
            for (var el in data) {
                let aux = data[el];
                let str = 'incidencia.ubicacion.' + aux.nombre_interno;
                if (aux.flag_equipos) {
                    arCollection.push(str);
                }
                this.scope.$watch(str, (nuevo) => {
                    if (nuevo !== undefined && nuevo != null && !nuevo.tipo.flag_equipos) {
                        var filter = {
                            "tipo.indice": nuevo.tipo.indice - 1,
                            "padre._id": nuevo._id
                        };

                        ubicacionService.getAll(filter)
                            .then((resp) => {
                                let data = resp.data.message;
                                if (data.length == 0) {
                                    alert("No existen ubicaciones dentro de la seleccionada");
                                } else {
                                    let ind = data[0].tipo.nombre_interno + 's';
                                    this.scope.aux.selects[ind] = data;
                                }
                            });
                    }

                    if (nuevo !== undefined && nuevo.tipo.flag_equipos) {
                        let ubicacion = nuevo._id;
                        let ubAux = this.scope.incidencia.ubicacion;
                        let keyMin = '';
                        let indexMin = 50;

                        for (var el in ubAux) {
                            let element = ubAux[el];
                            if (element.tipo.indice < 50) {
                                keyMin = el;
                                indexMin = element.tipo.indice;
                            }
                        }

                        let proyecto = this.scope.incidencia.proyecto._id;
                        let keyUbicacion = 'ubicacion.' + keyMin + '._id';

                        let filter = {
                            'tipo_equipo.sub_parte': false,
                            'proyecto._id': proyecto,
                        };
                        filter[keyUbicacion] = ubicacion;
                        // JSON.stringify(filter)
                        inventarioService.getAll(filter)
                            .then((resp, errp) => {
                                this.scope.aux.equipos = resp.data.message;
                            });

                        let keyUbicacionAlerta = 'ubicacion.' + keyMin + '._id';
                        let filterAlerta = {'tipo_equipo': nuevo.tipo_equipo._id};
                        // filterAlerta[keyUbicacionAlerta] = ubicacion;
                        alertasService.getAll(filterAlerta).then((resp, err) => {
                            this.scope.aux.alertas = resp.data.message;
                        });
                        this.scope.descripcionUbicacion = nuevo.descripcion;
                    }
                });
            }
        };

        centroCostosService.getAll().then((resp, err) => {
            this.scope.aux.centro_costos = resp.data.message;
        });

        unidadEjecutoraService.getAll().then((resp, err) => {
            this.scope.aux.unidad_ejecutora = resp.data.message;
        });

        prioridadesService.getAll().then((resp, err) => {
            this.scope.aux.prioridades = resp.data.message;
        });

        tipoIncidenciaService.getAll().then((resp, err) => {
            this.scope.aux.tipo_incidencias = resp.data.message;
        });

        estadosService.getAll()
            .then((resp, err) => {
                this.scope.aux.estados = resp.data.message;
            });

        this.scope.otra_ubicacion = () => {
            this.scope.aux.flag_precincidencia = false;
        };

        this.scope.esRequerido = (element) => {
            let result = true;
            let proyecto = this.scope.incidencia.proyecto;
            if(typeof proyecto !== "undefined" && proyecto != null) {
                if (typeof proyecto.no_requeridos !== "undefined" && proyecto.no_requeridos != null) {
                    if (typeof proyecto.no_requeridos.incidencias !== "undefined" && proyecto.no_requeridos.incidencias != null) {

                        result = proyecto.no_requeridos.incidencias.indexOf(element) == -1;
                    }
                }
            }
            return result;
        }
    }

    newIncidencia(data) {

        let self = this;
        this.scope.$watch("readOnly", function (newVal) {
            if (newVal) {
                self.location.path('/incidencia/');
            }
        });
        data.severidad = data.alerta.severidad;
        // if (this.scope.aux.preincidencias !== undefined) {
        // 	data.preincidencia = this.scope.aux.preincidencias;
        // }
        data.historial = [];
        let hist = {
            fecha: false,
            comentario: '-',
            valor_campo: data.observaciones,
            campo: 'Observaciones',
            fecha_cambio: new Date(),
            usuario: localStorage.getItem('usuario')
        };
        data.historial.push(hist);

        // let hist2 = {
        // 	fecha: false,
        // 	comentario: '',
        // 	valor_campo: '-',
        // 	campo: 'Observaciones',
        // 	fecha_cambio: new Date(),
        // 	usuario: localStorage.getItem('usuario')
        // }
        // data.historial.push(hist2);

        data.fecha_incidencia = data.fecha_incidencia.toISOString();
        data.fecha_reporte = data.fecha_reporte.toISOString();

        this.incidenciaService.save(data).then((resp, er) => {
            if (!er) {
                this.toastr.success('Incidencia creada correctamente!', 'Success!', {
                    timeOut: 2000,
                    closeButton: true
                });
                this.location.path('/incidencia/');
            }

        }).catch((er) => {
            this.toastr.error('Error', 'Error al crear la incidencia!', {
                timeOut: 2000,
                closeButton: true
            });
        });
    }

    crearOrdenTrabajo(data) {
        if (this.rootScope.ott) {
            this.rootScope.ott.push(data);
            this.location.path('/ott/list');
        } else {
            this.rootScope.ott = [];
            this.rootScope.ott.push(data);
            this.location.path('/ott/list');
        }
    }

    viewIncidencia(incidenciaService,
                   inventarioService,
                   alertasService,
                   severidadesService,
                   clientesService,
                   proyectosService,
                   centroCostosService,
                   unidadEjecutoraService,
                   prioridadesService,
                   tipoIncidenciaService,
                   tipoEquipoService,
                   usuariosService,
                   ubicacionService,
                   estadosService) {
        let id = this.routeParams.id;
        this.incidenciaService = incidenciaService;
        this.scope.f = {
            c: {
                inicio: false,
                fin: false
            },
            f: {
                inicio: false,
                fin: false
            },
            g: {
                instalacion: false
            }
        };

        this.scope.aux = {};
        this.scope.aux.selects = {};

        this.scope.toggle = (primero, segundo) => {
            this.scope.f[primero][segundo] = !this.scope.f[primero][segundo];
        };

        this.allWatch = function () {

            var watchIncidenciaPro = this.scope.$watch("incidencia.proyecto", (nuevo) => {
                if(typeof this.scope.incidencia.equipo !== 'undefined') {
                    let filter = {
                        'proyecto._id': nuevo._id,
                        '_id': this.scope.incidencia.equipo._id
                    };

                    this.scope.aux.deshabilitarEquipo = false;
                    inventarioService.getAll(filter).then((resp, err) => {
                        this.scope.aux.equipos = resp.data.message;
                        this.scope.aux.deshabilitarEquipo = true;
                        watchIncidenciaPro();
                    });
                }
            });


        }.bind(this);

        incidenciaService.getById({"_id": id})
            .then((resp, er) => {
                if (!er && resp.status == 200) {
                    this.scope.incidencia = resp.data.message;
                    this.scope.haveOtt = resp.data.haveOtt;
                    if(this.scope.haveOtt) {
                        this.scope.ottId = resp.data.ottId;
                    }

                    if (this.scope.incidencia.preincidencia) {
                        if (this.scope.incidencia.preincidencia.fecha_termino) {
                            this.scope.incidencia.preincidencia.fecha_termino = moment(this.scope.incidencia.preincidencia.fecha_termino).format('DD/MM/YYYY hh:mm');
                        }

                        if (this.scope.incidencia.preincidencia.fecha_envio) {
                            this.scope.incidencia.preincidencia.fecha_envio = moment(this.scope.incidencia.preincidencia.fecha_envio).format('DD/MM/YYYY hh:mm');
                        }
                    }

                    // this.scope.aux.fecha            = moment(this.scope.incidencia.preincidencia.);
                    this.scope.aux.fecha_incidencia = moment(this.scope.incidencia.fecha_incidencia);
                    this.scope.aux.fecha_reporte = moment(this.scope.incidencia.fecha_reporte);
                    if(typeof this.scope.incidencia.fecha_anulacion !== 'undefined') {
                        this.scope.aux.fecha_anulacion = moment(this.scope.incidencia.fecha_anulacion).format('DD-MM-YYYY hh:mm A');
                    }
                    this.scope.oldIncidencia = JSON.parse(JSON.stringify(this.scope.incidencia));
                }
                this.scope.aux.ultima_fecha_incidencia = moment(new Date());
                if(typeof this.scope.incidencia.equipo !== 'undefined') {
                    let f2 = new Date(this.scope.incidencia.equipo.fecha_instalacion) || new Date();
                    this.scope.aux.fecha_instalacion = moment(f2);
                }
                this.allWatch();
                this.ubicaciones();

            }).catch((er) => {
            console.log(er);
            console.log('Respuesta: ' + er.data.text);
        });

        this.ubicaciones = () => {
            let aux = this.scope.incidencia.ubicacion;
            let order = [];
            for (var el in aux) {
                order.push(aux[el]);
                this.scope.aux.selects[(aux[el].tipo.nombre_interno + 's')] = [aux[el]];
                this.scope.descripcionUbicacion = aux[el].descripcion;
            }
            // console.log(this.scope.aux.selects);
            // for (var el in order) {
            // 	let elemento = order[el];
            // 	this.scope.incidencia.ubicacion[elemento.tipo.nombre_interno] = [elemento];
            // }
            this.scope.aux.tipo_ubicaciones = order;
        }

        proyectosService.getAll().then((resp, err) => {
            if (!err) {
                this.scope.aux.proyectos = resp.data.message;
            }
        });

        centroCostosService.getAll().then((resp, err) => {
            this.scope.aux.centro_costos = resp.data.message;
        });

        unidadEjecutoraService.getAll().then((resp, err) => {
            this.scope.aux.unidad_ejecutora = resp.data.message;
        });

        alertasService.getAll().then((resp, err) => {
            this.scope.aux.alertas = resp.data.message;
        });

        prioridadesService.getAll().then((resp, err) => {
            this.scope.aux.prioridades = resp.data.message;
        });

        tipoIncidenciaService.getAll().then((resp, err) => {
            this.scope.aux.tipo_incidencias = resp.data.message;
        });

        tipoEquipoService.getAll().then((resp, err) => {
            this.scope.aux.tipo_equipos = resp.data.message;
        });

        // usuariosService.getById().
        // 	then((resp, err) => {
        // 		this.scope.aux.usuario = resp.data.message;
        // 	});

        estadosService.getAll()
            .then((resp, err) => {
                this.scope.aux.estados = resp.data.message;
            });

        this.scope.actualizarIncidencia = this.actualizarIncidencia.bind(this);

        this.scope.esRequerido = (element) => {
            let result = true;
            if(typeof this.scope.incidencia !== 'undefined' && this.scope.incidencia != null) {
                let proyecto = this.scope.incidencia.proyecto;
                if (typeof proyecto !== "undefined" && proyecto != null) {
                    if (typeof proyecto.no_requeridos !== "undefined" && proyecto.no_requeridos != null) {
                        if (typeof proyecto.no_requeridos.incidencias !== "undefined" && proyecto.no_requeridos.incidencias != null) {

                            result = proyecto.no_requeridos.incidencias.indexOf(element) == -1;
                        }
                    }
                }
            }
            return result;
        }
    }

    actualizarIncidencia() {
        let objOld = {
            "Prioridad": this.scope.oldIncidencia.prioridad,
            "Unidad ejecutora": this.scope.oldIncidencia.unidad_ejecutora,
            "Fecha incidencia": this.scope.oldIncidencia.fecha_incidencia,
            "Fecha reporte": this.scope.oldIncidencia.fecha_reporte,
            "Estado": this.scope.oldIncidencia.estado,
            "Fecha Instalacion Equipo": this.scope.oldIncidencia.equipo.fecha_instalacion
        }

        let objNew = {
            "Prioridad": this.scope.incidencia.prioridad,
            "Unidad ejecutora": this.scope.incidencia.unidad_ejecutora,
            "Fecha incidencia": this.scope.incidencia.fecha_incidencia.toISOString(),
            "Fecha reporte": this.scope.incidencia.fecha_reporte.toISOString(),
            "Estado": this.scope.incidencia.estado,
            "Fecha Instalacion Equipo": this.scope.incidencia.equipo.fecha_instalacion.toISOString()
        };

        // OJO si no se clona el obj viejo siempre es igual al obj nuevo
        if (DeepDiff.diff(objOld, objNew) !== undefined) {
            // let cambiosRaw = DeepDiff.diff(objOld, objNew);
            // let cambios = [];
            // let aux = {};
            //
            // for (var i = 0; i < cambiosRaw.length; i++) {
            // 	if (cambiosRaw[i].path.length == 1) {
            // 		if (aux[cambiosRaw[i].path[0]] === undefined) {
            // 			let nuevo = cambiosRaw[i];
            // 			cambios.push(nuevo);
            // 			aux[cambiosRaw[i].path[0]] = 1;
            // 		}
            // 	}else{
            // 		if (cambiosRaw[i].path[1] == 'nombre') {
            // 			let nuevo = cambiosRaw[i];
            // 			cambios.push(nuevo);
            // 			aux[cambiosRaw[i].path[0]] = 1;
            // 		}
            // 	}
            //
            // }

            let templateModal = `
				<!-- Modal content-->
    			<div class="modal-content">
      				<div class="modal-header">
      					<h4 style="text-align:center;" class="modal-title">Agrega un comentario</h4>
      				</div>
      				<div class="modal-body">
				        <input class="form-control" ng-model="comentario">
				    </div>
				    <div class="modal-footer">
				        <div class="btn btn-danger" ng-click="mv.close(false)">Cerrar</div>
						<div class="btn btn-success pull-right" ng-click="mv.close(true, comentario)">Agregar</div>
				    </div>
      			</div>
			`;

            // for (var i = 0; i < cambios.length; i++) {

            let modal = this.uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                // ariaDescribedBy: cambios[i].path[0],
                template: templateModal,
                controller: function () {
                    // this.campo = campo;
                    // this.valor = valor;
                    this.close = function (flag, comentario) {
                        modal.close({
                            // input : input,
                            comentario: comentario,
                            // campo: this.campo,
                            // valor: this.valor,
                            // index: modalIndex
                        });
                    };
                },
                controllerAs: 'mv',
                size: 'md',
                resolve: {
                    // campo: function() {
                    // 	let raw = cambios[i].path[0];
                    // 	return raw;
                    // },
                    // valor: function() {
                    // 	return cambios[i].rhs
                    // }
                }
            });

            modal.result.then((respuesta) => {
                let objHistorial = {};
                // let name = localStorage.getItem('usuario');
                let name = this.scope.info.get('nombre') + ' ' + this.scope.info.get('apellido');
                // if (respuesta.campo.indexOf('Fecha') == 0) {
                // 	this.scope.incidencia.historial.push({
                // 		fecha_cambio: moment().toISOString(),
                // 		campo: respuesta.campo,
                // 		valor_campo: respuesta.valor,
                // 		comentario: respuesta.comentario,
                // 		fecha: true,
                // 		usuario: name
                // 	});
                // }else{
                this.scope.incidencia.historial.push({
                    fecha_cambio: moment().toISOString(),
                    campo: respuesta.campo,
                    valor_campo: respuesta.valor,
                    comentario: respuesta.comentario,
                    fecha: false,
                    usuario: name
                });
                // }

                // if (respuesta.index == (cambios.length -1)) {
                this.incidenciaService.update(this.scope.incidencia)
                    .then((resp, err) => {
                        this.toastr.success('Incidencia actualizada correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        this.location.path('/incidencia/');
                    });
                // }
            }, () => {
                console.log('Modal dismissed at: ' + new Date());
            });
            // }

        } else {
            console.log('no hay cambios detectados');
        }
    }

    addObservacion() {
        let templateModal = `
				<!-- Modal content-->
				<div class="modal-content">
					<div class="modal-header">
						<h4 style="text-align:center;" class="modal-title">Agregar observación</h4>
					</div>
					<div class="modal-body">
						<textarea style="width:100%;" ng-model="aux.addObservacion"></textarea>
				    </div>
				    <div class="modal-footer">
						<div class="btn btn-danger pull-right" ng-click="mv.cerrar()">Cancelar</div>
						<div class="btn btn-success pull-right" ng-click="mv.cerrar(aux.addObservacion)">Agregar</div>
				    </div>
				</div>
			`;
        var modalInstance = this.uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: templateModal,
            controller: function () {
                this.aux = {};
                this.cerrar = function (input) {
                    modalInstance.close(input);
                };
            },
            controllerAs: 'mv',
            size: 'sm'
        });

        modalInstance.result.then((data) => {
            if (data === undefined) {
                return false;
            }
            let name = this.scope.info.get('nombre') + ' ' + this.scope.info.get('apellido');
            this.scope.incidencia.historial.push({
                fecha_cambio: new Date(),
                campo: 'Observaciones',
                valor_campo: data,
                comentario: '-',
                usuario: name
            });
            this.incidenciaService.update(this.scope.incidencia)
                .then((resp, err) => {
                    //window.location.reload(false);
                });

        }, () => {
            console.log('Modal dismissed at: ' + new Date());
        });
    }

    anularIncidencia() {

        let templateModal = `
				<!-- Modal content-->
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title text-center"><strong> Confirmar anulación incidencia</strong></h4>
					</div>
					<div class="modal-body">
					    <div class="form-group">
                            <label for="middle-name" class="control-label col-md-4 col-sm-4 col-xs-12">Fecha</label>
                            <div class="col-md-8 col-sm-8 col-xs-12">
                                <div class="form-control"
                                    style="border: 1px"
                                    ng-model="mv.fecha_anulacion"
                                    moment-picker="mv.aux.fecha_anulacion"
                                    format="DD-MM-YYYY, h:mm a" required>
                                    {{mv.aux.fecha_anulacion}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="middle-name" class="control-label col-md-4 col-sm-4 col-xs-12">Observación</label>
                            <div class="col-md-8 col-sm-8 col-xs-12">
						        <textarea  ng-model="aux.addObservacion" style="width:100%; border: 1px;"></textarea>
						     </div>
						 </div>
				    </div>
				    <div class="modal-footer">
				    	<div class="btn btn-default pull-left" ng-click="mv.cerrar()">Cancelar</div>
						<div class="btn btn-success pull-right" ng-click="mv.cerrar(aux.addObservacion)">Confirmar</div>
				    </div>
				</div>
			`;
        var modalInstance = this.uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            template: templateModal,
            controller: function () {
                this.aux = {
                    fecha_anulacion: moment()
                };
                this.cerrar = function (input) {
                    modalInstance.close({
                        fecha_anulacion: this.fecha_anulacion,
                        input: input
                    });
                };
            },
            controllerAs: 'mv',
            size: 'md'
        });

        modalInstance.result.then((data) => {
            if (data.input === undefined) {
                return false;
            }

            let name = this.scope.info.get('nombre') + ' ' + this.scope.info.get('apellido');

            let datak = {
                _id: this.scope.incidencia._id,
                fecha_anulacion: data.fecha_anulacion.toISOString(),
                observacion: {
                    fecha_cambio: new Date(),
                    campo: 'Estado',
                    valor_campo: 'Anulada',
                    comentario: data.input,
                    usuario: name
                }
            };

            this.incidenciaService.anular(datak)
                .then((resp, err) => {
                    this.toastr.success('Incidencia anulada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/incidencia/');
                });

        }, () => {
            console.log('Modal dismissed at: ' + new Date());
        });


        // let update = {
        // 	_id: this.scope.incidencia._id,
        // 	$set:{
        // 		'activo': false
        // 	}
        // };
        //
        // this.incidenciaService.update(update)
        // 	.then((resp) => {
        // 		console.log(resp);
        // 	}).catch((err) => {
        // 		console.log(err);
        // 	});
    }

    getUbicacion(ub) {
        let resp = '';
        for (var el in ub) {
            let element = ub[el].nombre;
            resp += element + '/ ';
        }
        return resp;
    };

    getPdf() {
        let data = {
            _id: this.scope.incidencia._id
        }
        this.incidenciaService.pdf(data)
            .then((resp) => {
                var url = window.location;
                var urlNew = this.baseUrl + '/api/incidencias/pdf/' + resp.data.nombre + '?token=' + localStorage.getItem('token');
                window.open(urlNew);
            });
    }

    handleDisplayFilters() {
        this.scope.displayFilters = !this.scope.displayFilters;
    }
}



// WEBPACK FOOTER //
// ./app/js/controllers/incidencia/incidencias.js